import { FC } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import BugReportIcon from '@mui/icons-material/BugReport';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import ReplyIcon from '@mui/icons-material/Reply';
import UserMenu from '../../../Navigation/UserMenu';
import './CodeEditorPanel.scss';

type CodeEditorPanelProps = {
	theme: string;
	runCode: () => void;
	testCode?: () => void;
	reset?: () => void;
	postToComments: () => void;
	expand: () => void;
	changeView: () => void;
	save: () => void;
	handleGoBack: () => void;
	pageView?: boolean;
	backButton?: boolean;
};

const CodeEditorPanel: FC<CodeEditorPanelProps> = ({
	theme,
	runCode,
	postToComments,
	expand,
	testCode,
	reset,
	changeView,
	save,
	handleGoBack,
	pageView,
	backButton,
}) => {
	const { t } = useTranslation();
	const showChangeView = false;
	return (
		<div className={`CodeEditorPanel ${theme}`}>
			<div>
				<Button
					startIcon={<PlayArrowIcon />}
					onClick={runCode}
					sx={{ marginRight: '20px' }}
				>
					{t('runCode')}
				</Button>
				{testCode && (
					<Button
						startIcon={<BugReportIcon />}
						onClick={testCode}
						sx={{ marginRight: '20px' }}
					>
						{t('testCode')}
					</Button>
				)}
				<Button
					startIcon={<RestartAltIcon />}
					onClick={reset}
					sx={{ marginRight: '20px' }}
				>
					{t('reset')}
				</Button>
				{!pageView && (
					<Button
						startIcon={<SendIcon />}
						onClick={postToComments}
						sx={{ marginRight: '20px' }}
					>
						{t('postToComments')}
					</Button>
				)}
				<Button
					startIcon={<SaveIcon />}
					onClick={save}
					sx={{ marginRight: '20px' }}
				>
					{t('save')}
				</Button>
				{/* {!expandView && ( */}
				{!pageView && (
					<Button
						startIcon={<AspectRatioIcon />}
						onClick={expand}
						sx={{ marginRight: '20px' }}
					>
						{t('expand')}
					</Button>
				)}
				{/* )} */}
				{showChangeView && (
					<Button
						startIcon={<ViewQuiltIcon />}
						onClick={changeView}
						sx={{ marginRight: '20px' }}
					>
						{t('changeView')}
					</Button>
				)}

				<Button
					startIcon={<ReplyIcon />}
					onClick={handleGoBack}
					sx={{ marginRight: '20px' }}
				>
					{backButton ? t('back') : t('to_courses')}
				</Button>
			</div>
			{pageView && (
				<div style={{ background: '#fff', display: 'inline-flex' }}>
					<UserMenu />
				</div>
			)}
		</div>
	);
};

export default CodeEditorPanel;
